import { render, staticRenderFns } from "./EntityDocDigitalForm.vue?vue&type=template&id=bce53190&"
import script from "./EntityDocDigitalForm.vue?vue&type=script&lang=js&"
export * from "./EntityDocDigitalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bce53190')) {
      api.createRecord('bce53190', component.options)
    } else {
      api.reload('bce53190', component.options)
    }
    module.hot.accept("./EntityDocDigitalForm.vue?vue&type=template&id=bce53190&", function () {
      api.rerender('bce53190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/EntityDocDigitalForm.vue"
export default component.exports